module.exports = __webpack_public_path__ + "static/01-0d64da9a18239ff1b663b0c9f2e5d13a.svg";